// Standalone so `routeURLs` and the router can use these tabs without importing the page itself,
// which would pull the page and its dependencies into the initial bundle.
export enum JETCARD_LIST_TABS {
  AGREEMENTS = 'agreements',
  PROMOTIONS = 'promotions',
  ADDITIONAL_TERMS = 'additional-terms',
  PROMOTIONAL_TERMS = 'promotional-terms',
  STATEMENTS = 'statements',
}
